var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCoffin = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 48,
  viewBox: "0 0 32 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.3967 0H6.60319L0.902344 13.0525L7.28925 48H24.7104L31.0973 13.0525L25.3967 0ZM21.1042 13.7031H17.4063V23.4632H14.5936V13.7031H10.8957V10.8905H14.5936V6.54056H17.4062V10.8904H21.1041V13.7031H21.1042Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCoffin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_coffin.fdaf599b.svg";
export { ForwardRef as ReactComponent };